export enum NavigationRegions {
  PrimaryMenu = '@trustedshops/tswp-carrier-employees:primary-menu',
  SecondaryMenu = '@trustedshops/tswp-carrier-employees:secondary-menu',
  TertiaryMenu = '@trustedshops/tswp-carrier-employees:tertiary-menu',
  LegalMenu = '@trustedshops/tswp-carrier-employees:legal-menu',
  MetaMenu = '@trustedshops/tswp-carrier-employees:meta-menu',
}
